var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcAddContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.267a6.14 6.14 0 01-6.133-6.134A6.14 6.14 0 0112.5 1a6.14 6.14 0 016.133 6.133 6.14 6.14 0 01-6.133 6.134zm0-11.152a5.024 5.024 0 00-5.018 5.018 5.024 5.024 0 005.018 5.019 5.024 5.024 0 005.018-5.019A5.024 5.024 0 0012.5 2.115zM14.225 24h-11.5C1.774 24 1 23.162 1 22.131c0-.084.016-2.099 1.409-4.111.811-1.171 1.921-2.101 3.299-2.765 1.683-.811 3.775-1.222 6.217-1.222.403 0 .802.013 1.186.039.317.022.558.317.538.661-.02.343-.294.605-.61.583a16.126 16.126 0 00-1.114-.037c-4.01 0-6.969 1.187-8.558 3.433-1.19 1.683-1.217 3.405-1.217 3.422 0 .341.258.62.575.62h11.5c.318 0 .575.279.575.623s-.257.623-.575.623z",
    fill: "#414042",
    stroke: "#00000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.633 24a5.372 5.372 0 01-5.366-5.367 5.372 5.372 0 015.366-5.366A5.372 5.372 0 0124 18.633 5.372 5.372 0 0118.633 24zm0-9.541a4.18 4.18 0 00-4.174 4.174 4.179 4.179 0 004.174 4.174 4.178 4.178 0 004.174-4.174 4.179 4.179 0 00-4.174-4.174z",
    fill: "#414042",
    stroke: "#00000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.087 18.02h-1.84v-1.84a.613.613 0 00-1.227 0v1.84h-1.84a.613.613 0 000 1.227h1.84v1.84a.614.614 0 001.227 0v-1.84h1.84a.614.614 0 000-1.227z",
    fill: "#414042",
    stroke: "#00000000"
  })));
}

export default SvgIcAddContact;